export const FEEDBACK_NON_RICHIESTO = '0';
export const FEEDBACK_RICHIESTO = '1';
export const FEEDBACK_RILASCIATO = '2';
export const FEEDBACK_CONFERMATO = '3';
export const FEEDBACK_WEMI_RICHIESTO = 1;
export const FEEDBACK_WEMI_RILASCIATO = 3;
